import { useEffect, useState } from "react";
import { listNotifications } from "../api/support.ts";
import { useAuth } from "../context/auth.tsx";
import { Layout } from "../components/layout.tsx";

interface Notification {
  id: string;
  title: string;
  body: string;
  notificationType: string;
  status: string;
  createdAt: string;
}

export function SupportActivityPage() {
  const { token } = useAuth();
  const [events, setEvents] = useState<Notification[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    void listNotifications(token, { limit: 100 }).then((d) => {
      setEvents((d as { items: Notification[] }).items ?? []);
      setLoading(false);
    });
  }, []);

  return (
    <Layout>
      <div className="mx-auto max-w-4xl p-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-white">Activity Feed</h1>
          <p className="mt-1 text-gray-400">
            All support events and notifications in chronological order
          </p>
        </div>
        {loading ? (
          <p className="text-gray-400">Loading...</p>
        ) : (
          <div className="space-y-2">
            {events.length === 0 && <p className="text-gray-400">No activity yet.</p>}
            {events.map((e) => (
              <div key={e.id} className="flex items-start gap-3 border-b border-gray-800 py-3">
                <div className="mt-2 h-2 w-2 shrink-0 rounded-full bg-indigo-500" />
                <div className="flex-1">
                  <p className="text-sm text-white">{e.title}</p>
                  <p className="mt-0.5 text-xs text-gray-400">{e.body}</p>
                </div>
                <div className="shrink-0 text-right">
                  <span className="text-xs text-gray-500">
                    {new Date(e.createdAt).toLocaleString()}
                  </span>
                  <p className="mt-0.5 text-xs text-gray-600">{e.notificationType}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
